
export default class FixBug {
    constructor() {
        const links = document.querySelectorAll('.b-text-image-links__content__links a')
        const linksImage = document.querySelectorAll('.b-text-image-links__content__images .image')

        if (links.length > 0) {
            links[0].classList.add('--active')
            links.forEach((link, index) => {
                link.addEventListener('click', () => {
                    // event.preventDefault()
                    links.forEach((lnk) => lnk.classList.remove('--active'))
                    linksImage.forEach((img) => img.classList.remove('--active'))

                    link.classList.add('--active')
                    linksImage[index].classList.add('--active')
                })
            })
        }
    }
}
